document.addEventListener("DOMContentLoaded", function () {

  // debut toggle footer
  const titles = document.querySelectorAll("#block-f451f2aa-aca0-4cb7-9181-3751b08d6451 .footer__item-title, #block-3aa9984d-0866-435a-9341-f87f88a35464 .footer__item-title, #block-footer_item_4LtdXP .footer__item-title, #block-footer_item_kpiRfb .footer__item-title");
  titles.forEach(title => {
    title.addEventListener("click", function(){
      if(window.innerWidth <= 992){
        const content = this.nextElementSibling;
        this.classList.toggle("active");
        content.classList.toggle("open");
      }
    });
  });
  // fin toggle footer

  // debut voir plus description categorie
  if(!document.body.classList.contains('collection')) return;

  const sections = document.querySelectorAll('[id^="shopify-section-template--"][id*="rich_text"] .text-container');

  sections.forEach(function(el){

    el.classList.add('is-collapsed');

    const btn = document.createElement("span");
    btn.className = "description-toggle button button--primary";
    btn.innerText = "Voir plus";

    el.after(btn);

    btn.addEventListener("click", function(){

      el.classList.toggle("is-collapsed");

      btn.innerText = el.classList.contains("is-collapsed")
        ? "Voir plus"
        : "Voir moins";

    });

  });
  // fin voir plus description categorie
});
